import React, { forwardRef, useEffect, useState } from 'react'
import { useInView } from 'react-intersection-observer'
import axios from 'axios'

import ArtisanTopHeadline from '../ArtisanTopHeadline'
import ArtisanTopDescription from '../ArtisanTopDescription'
import InstagramCarousel, { InstagramPost } from '../InstagramCarousel'
import MixBlendContainer from '../MixBlendContainer/index'
import BlurContainer from '../BlurContainer'
import InstagramCarouselTabNew from '../InstagramCarouselTabNew'
import { sendError } from '@models/Sentry'
import { useTranslation } from '@models/Translation'

import * as style from './style.module.sass'

const InstagramSection = forwardRef<HTMLElement>((_, sectionRef) => {
  const { t, locale } = useTranslation()
  const USER_ID = '17841464807255871'
  const ACCESS_TOKEN =
    'EAAKkyp4yMDoBO8RxUXcx4Xsxt0tKG6eCHsXZB8OyEzIABJZBa9PjmIx4iaDXgP4zU0BXns97MFy79hzVgzvkJn3TUjaV5VFWZALsAudCsQUjnfyhCzVr5ZBu0seT87sknBEY5xIUdJA2iQpLO11ZA2UeW1bknq8lNksqGNsdd8j7mBi0EQbF6LbK6a3pYnaMZD'
  const [posts, setPosts] = useState<InstagramPost[]>([])
  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: true,
  })

  useEffect(() => {
    if (!inView) return

    axios
      .get(
        `https://graph.facebook.com/v19.0/${USER_ID}?fields=media{media_url,permalink,media_type,caption,children{media_url}}&access_token=${ACCESS_TOKEN}`,
      )
      .then(response => {
        setPosts(
          response.data.media.data.flatMap(
            (post: {
              media_url: string
              permalink: string
              media_type: string
              caption?: string
              children?: { data: { media_url: string }[] }
            }) => {
              const { media_url, permalink, media_type, caption, children } =
                post
              if (children && children.data.length >= 1) {
                return children.data.map(child => ({
                  mediaUrl: child.media_url,
                  permalink,
                  mediaType: media_type,
                  caption,
                }))
              }

              return {
                mediaUrl: media_url,
                permalink,
                mediaType: media_type,
                caption,
              }
            },
          ),
        )
      })
      .catch(error => {
        console.error(JSON.stringify(error))
        sendError(error)
      })
  }, [inView])

  return (
    <section className={style.section} ref={sectionRef}>
      <MixBlendContainer>
        <BlurContainer>
          <div className={style.headline} ref={ref}>
            <div className={style.container}>
              <ArtisanTopHeadline heading="Instagram" isRight />
              <div className={style.description}>
                <ArtisanTopDescription
                  descriptionLines={[
                    t('artisan.instagram1'),
                    t('artisan.instagram2'),
                  ]}
                  isRight
                  isForcedBreak={locale === 'en'}
                />
              </div>
            </div>
          </div>
        </BlurContainer>
      </MixBlendContainer>
      <div className={style.pcCarousel}>
        <InstagramCarousel posts={posts} />
      </div>
      <div className={style.tabCarousel}>
        <InstagramCarouselTabNew posts={posts} />
      </div>
    </section>
  )
})

export default InstagramSection
